export const typeMapping = value => {
  const text =
    {
      1: "Quilo",
      2: "Unidade",
      3: "Não atribuído"
    }[value] || value;
  return text;
};
